import { initialState } from ".";
import {
    SET_SESSION_DATA,
    LOGIN_REQUEST_START,
    LOGIN_REQUEST_FAIL,
    LOGIN_REQUEST_SUCCESS,
    CURRENT_USER_REQUEST_FAIL,
    CURRENT_USER_REQUEST_START,
    CURRENT_USER_REQUEST_SUCCESS,
    LOGOUT
} from "../actions/session";

export default function (session = initialState.session, action) {
    switch (action.type) {
        case SET_SESSION_DATA:
            // Set the data, excluding some reserved values, such as user.
            let { user, ...data } = action.data;
            return {
                ...session,
                ...data
            }

        case LOGIN_REQUEST_START:
        case CURRENT_USER_REQUEST_START:
            return {
                ...session,
                loginError: null,
                loading: true
            }

        case CURRENT_USER_REQUEST_SUCCESS:
            return {
                ...session,
                loading: false,
                loginError: null,
                user: action.user,
                ready: true
            }

        case LOGIN_REQUEST_SUCCESS:
            return {
                ...session,
                loading: false,
                loginError: null,
                user: action.user,
                token: action.token,
                ready: true
            }

        case CURRENT_USER_REQUEST_FAIL:
        case LOGIN_REQUEST_FAIL:
            return {
                ...session,
                loginError: action.error || "Unknown error.",
                loading: false,
                ready: true
            }

        case LOGOUT:
            return {
                ...session,
                loading: false,
                loginError: null,
                user: null,
                token: null
            }

        default:
            return session;
    }
}